/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { connect } from 'react-redux';

import { CMS_PAGE } from 'Component/Header/Header.config';
import {
    CmsPageContainer as SourceContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps
} from 'SourceRoute/CmsPage/CmsPage.container';
import { setNoBreadcrumbsBorder } from 'Store/Breadcrumbs/Breadcrumbs.action';
import history from 'Util/History';
import { debounce } from 'Util/Request';
import { isHomePageUrl } from 'Util/Url';

import { LOADING_TIME } from './CmsPage.config';

export const BreadcrumbsDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Breadcrumbs/Breadcrumbs.dispatcher'
);

/** @namespace Pwa/Route/CmsPage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    setNoBreadcrumbsBorder: (meta) => dispatch(setNoBreadcrumbsBorder(meta))
});

/** @namespace Pwa/Route/CmsPage/Container */
export class CmsPageContainer extends SourceContainer {
    __construct(props) {
        super.__construct(props);

        this.updateBreadcrumbs();
        props.setNoBreadcrumbsBorder(true);
    }

    componentWillUnmount() {
        const { setNoBreadcrumbsBorder } = this.props;

        setNoBreadcrumbsBorder(false);
    }

    onPageLoad = ({ cmsPage: page }) => {
        const {
            location: { pathname },
            updateMeta,
            setHeaderState,
            updateBreadcrumbs
        } = this.props;

        const {
            content_heading,
            meta_title,
            title,
            meta_description,
            meta_keywords
        } = page;

        debounce(this.setOfflineNoticeSize, LOADING_TIME)();
        const firstIndex = title.indexOf('[');
        const lastIndex = title.indexOf(']');
        const lang = firstIndex >= 0 && lastIndex > 0 ? title.slice(firstIndex, (lastIndex + 1) - firstIndex) : '';
        const pageData = page;
        pageData.title = lang ? title.replace(lang, '') : title;
        updateBreadcrumbs(pageData);
        updateMeta({
            title: meta_title || title,
            description: meta_description,
            keywords: meta_keywords,
            canonical_url: window.location.href
        });

        if (!isHomePageUrl(pathname)) {
            setHeaderState({
                name: CMS_PAGE,
                title: content_heading,
                onBackClick: () => history.goBack()
            });
        }

        this.setState({ page, isLoading: false, isPageLoaded: true });
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CmsPageContainer);
